import React from 'react';
import imgBrand from '../assets/img/brand.svg';
import { Link } from 'react-router-dom';

const Brand = () => (
  <Link to="/">
    <img style={{ width: 215 }} src={imgBrand} alt="Emprouen Advisors" />
  </Link>
);

export default Brand;
